module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/f011f09e649e804c4c0c8275a7d1ba5b.png";